<template>
  <div id="pmlst-outcome">
    <div class="pmlst-outcome-wrapper">
      <div class="pmlst-outcome-extra-wrapper">
        <div class="outcome">
          <monistat-symptom-checker-outcome :outcome="outcome" />
        </div>
        <div class="actions">
          <restart-button
            :restart="{
              icon: 'fas fa-sync',
              text: 'Restablecer el verificador de síntomas'
            }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MonistatSymptomCheckerOutcome from '@/components/MonistatSymptomCheckerOutcome'
import RestartButton from '@/components/RestartButton'

export default {
  name: 'pure-outcome-screen',
  components: { MonistatSymptomCheckerOutcome, RestartButton },
  props: {
    outcome: {
      type: Object,
      required: true
    }
  }
}
</script>
